// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

export class Enum {
    public static IsDefined (enumeration, val): boolean {
        for (const key in enumeration) {
            if (enumeration[key] === val) {
                return true;
            }
        }
        return false;
    }
}
